import React from 'react';
import { FormFieldSC } from './form-field.styled';
import { FormCtx } from '../form-context/form-context';
import { FormFieldProps } from '@common/types/hilbi-form';
import FieldErrorMessage from './../field-error-message/field-error-message';
import FieldLabel from '@common/components/hilbi-form/field-label/field-label';
import { HorizontalFormFieldSC } from './horizontal-form-field.styled';

const FormField: React.FC<FormFieldProps> = ({
  children,
  error,
  label,
  required,
  icon,
  disabled,
  className,
  ...rest
}) => {
  return (
    <FormCtx.Consumer>
      {(hilbiFormCtx) =>
        hilbiFormCtx.direction === 'horizontal' ? (
          <HorizontalFormFieldSC
            haveLabel={!!label}
            disabled={disabled}
            className={className}
          >
            <div className={'content'}>
              <div className={'meta'}>
                {label ? <FieldLabel label={label} /> : null}
                {icon ? (
                  <div className={'icon'}>
                    <img src={icon} width="40" height="40" alt={'icon'} />
                  </div>
                ) : null}
                {required ? <span className={'required'}>*</span> : null}
              </div>
              <div className={'wrapped-comp'}>
                {React.cloneElement(children, {
                  ...hilbiFormCtx,
                  ...rest,
                  error: !!error,
                  disabled,
                })}
                <FieldErrorMessage message={error} />
              </div>
            </div>
          </HorizontalFormFieldSC>
        ) : (
          <FormFieldSC>
            <FieldLabel label={label} />
            {required ? <span className={'required'}>*</span> : null}
            <div className={'wrapped-comp'}>
              {React.cloneElement(children, {
                ...hilbiFormCtx,
                ...rest,
                error: !!error,
                disabled,
              })}
            </div>
            <FieldErrorMessage message={error} />
          </FormFieldSC>
        )
      }
    </FormCtx.Consumer>
  );
};

export default FormField;
